import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	taskOneDescriptionPrimaryAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-one-description-primary-admin-non-final',
		defaultMessage: `
You can manage users’ access to operations by giving them an **Admin**, **User**, or a **custom role**.
**Admins** can create and manage on-call teams, while **Users** can use their team’s operations without any admin permissions.<br/><br/>
To manage users and roles, go to **Jira settings > Products > Role assignment** or **Custom roles**.
        `,
		description:
			'Transition home users and roles step task one description when user is primary admin',
	},
	taskTwoDescriptionPrimaryAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-two-description-primary-admin-non-final',
		// TODO replace URL
		defaultMessage: `
They are an admin in Opsgenie but aren’t a product admin in Jira Service Management.<br/><br/>
Contact your organization admin to give them the **product admin** role in Jira Service Management so they can continue to have the access to configure operations. 
[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)
`,
		description:
			'Transition home users and roles step task two description when user is primary admin',
	},
	taskTwoEmptyDescriptionPrimaryAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-two-empty-description-primary-admin-non-final',
		defaultMessage:
			'Users who were an Opsgenie admin are now a product admin in Jira Service Management. They have the access to configure operations.',
		description:
			'Transition home users and roles step task two empty description when user is primary admin',
	},
	taskThreeDescriptionPrimaryAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-three-description-primary-admin-non-final',
		// TODO replace URL
		defaultMessage: `
They have a custom role in Opsgenie that isn’t supported by Jira Service Management, so they currently have a User role.<br/><br/>
Contact your organization admin to give them the **product admin** role in Jira Service Management so they can continue to have the access to configure operations. 
[Read how to make someone a product admin](https://support.atlassian.com/user-management/docs/give-users-admin-permissions/#Make-someone-a-product-admin)
`,
		description:
			'Transition home users and roles step task three description when user is primary admin',
	},
	taskThreeEmptyDescriptionPrimaryAdminNonFinal: {
		id: 'eoc-changeboarding.transition-home.users-and-roles-step.primary-admin.task-three-empty-description-primary-admin-non-final',
		defaultMessage:
			'Users who had a custom role in Opsgenie that isn’t supported by Jira Service Management are now given a different role.',
		description:
			'Transition home users and roles step task three empty description when user is primary admin',
	},
});
